(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rb-cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-rb-cart]');
    if (!root) return;

    var panel   = root.querySelector('[data-rb-cart-panel]');
    var body    = root.querySelector('[data-rb-cart-body]');
    var foot    = root.querySelector('[data-rb-cart-foot]');
    var empty   = root.querySelector('[data-rb-cart-empty]');
    var countEl = root.querySelector('[data-rb-cart-count]');
    var totalEl = root.querySelector('[data-rb-cart-total]');
    var locale  = document.documentElement.lang || 'cs';
    var lastFocus = null;

    // URL z data-atributů (Liquid se uvnitř {% javascript %} nevyhodnotí)
    var urls = {
      cart:   root.getAttribute('data-cart-url')        || '/cart',
      add:    root.getAttribute('data-cart-add-url')    || '/cart/add',
      change: root.getAttribute('data-cart-change-url') || '/cart/change'
    };

    function money(cents, currency) {
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency || 'CZK', maximumFractionDigits: 0 }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(0) + ' ' + (currency || '');
      }
    }

    function esc(str) {
      var d = document.createElement('div');
      d.textContent = str == null ? '' : str;
      return d.innerHTML;
    }

    function render(cart) {
      countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
      // Zrcadlí se do všech počítadel v hlavičce
      document.querySelectorAll('[data-rb-cart-badge]').forEach(function (b) {
        b.textContent = cart.item_count;
      });

      if (!cart.item_count) {
        body.hidden = true; foot.hidden = true; empty.hidden = false;
        return;
      }
      body.hidden = false; foot.hidden = false; empty.hidden = true;

      body.innerHTML = cart.items.map(function (item) {
        var img = item.image
          ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="" loading="lazy">'
          : '';
        var author = item.vendor ? '<span class="rb-cart__item-author">' + esc(item.vendor) + '</span>' : '';
        return '' +
          '<div class="rb-cart__item" data-key="' + item.key + '">' +
            '<a class="rb-cart__item-media" href="' + item.url + '">' + img + '</a>' +
            '<div class="rb-cart__item-main">' +
              '<a class="rb-cart__item-title" href="' + item.url + '">' + esc(item.product_title) + '</a>' +
              author +
              '<span class="rb-cart__item-price">' + money(item.final_line_price, cart.currency) + '</span>' +
            '</div>' +
            '<div class="rb-cart__item-side">' +
              '<span class="rb-cart__qty">' +
                '<button type="button" data-rb-dec aria-label="Ubrat kus">&minus;</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-rb-inc aria-label="Přidat kus">+</button>' +
              '</span>' +
              '<button type="button" class="rb-cart__remove" data-rb-remove>Odebrat</button>' +
            '</div>' +
          '</div>';
      }).join('');

      totalEl.textContent = money(cart.total_price, cart.currency);
    }

    function fetchCart() {
      return fetch(urls.cart + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render);
    }

    function change(key, quantity) {
      root.classList.add('is-busy');
      return fetch(urls.change + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(render)
        .finally(function () { root.classList.remove('is-busy'); });
    }

    function open() {
      lastFocus = document.activeElement;
      root.hidden = false;
      // vynutí reflow, ať transition proběhne
      root.offsetHeight;
      root.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var closeBtn = root.querySelector('[data-rb-cart-close]');
      if (closeBtn) closeBtn.focus();
      fetchCart();
    }
    function close() {
      root.classList.remove('is-open');
      document.body.style.overflow = '';
      var onEnd = function () {
        root.hidden = true;
        panel.removeEventListener('transitionend', onEnd);
      };
      panel.addEventListener('transitionend', onEnd);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    // Otevření z hlavičky
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-rb-cart-open]');
      if (opener) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-rb-cart-close]')) { close(); }
    });

    // Ovládání položek (delegováno, přežije překreslení)
    body.addEventListener('click', function (e) {
      var itemEl = e.target.closest('.rb-cart__item');
      if (!itemEl) return;
      var key = itemEl.getAttribute('data-key');
      var qtyEl = itemEl.querySelector('.rb-cart__qty span');
      var qty = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;

      if (e.target.closest('[data-rb-inc]'))    change(key, qty + 1);
      else if (e.target.closest('[data-rb-dec]')) change(key, qty - 1);
      else if (e.target.closest('[data-rb-remove]')) change(key, 0);
    });

    // Esc zavírá
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    // Přidání do košíku odkudkoli otevře drawer místo skoku na /cart
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('form[action$="/cart/add"], form[action*="/cart/add"]')) return;
      e.preventDefault();
      root.classList.add('is-busy');
      fetch(urls.add + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json(); })
        .then(function () { root.classList.remove('is-busy'); open(); })
        .catch(function () { root.classList.remove('is-busy'); form.submit(); });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
